/** `/c/$companyId/purchases/credits?tab&supplier` — the supplier credits list. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CREDIT_LIST_TABS } from "../api/codes";
import { SupplierDocList } from "../bills/list/SupplierDocList";

const search = z.object({
  tab: z.enum(CREDIT_LIST_TABS).optional().catch(undefined),
  supplier: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/credits/")({
  validateSearch: (raw) => search.parse(raw),
  component: CreditsRoute,
});

function CreditsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { tab, supplier } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SupplierDocList
      companyId={companyId}
      kind="vendor-credits"
      tab={tab ?? "all"}
      supplier={supplier}
      onSearch={(next) =>
        void navigate({
          search: { tab: CREDIT_LIST_TABS.find((id) => id === next.tab), supplier: next.supplier },
          replace: true,
        })
      }
    />
  );
}
